









import { Component, Prop, Vue } from 'vue-property-decorator';
import { GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import { TranslateResult } from 'vue-i18n';

interface IPaycheckPeriodMarker {
  icon: string;
  className: string;
  message: TranslateResult;
}

@Component({})
export default class PaycheckPeriodMarker extends Vue {
  @Prop({ required: true }) private paycheckPeriod!: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods;

  private get paycheckPeriodMarker(): IPaycheckPeriodMarker | null {
    if (this.paycheckPeriod.isLocked) {
      return {
        icon: 'lock',
        className: 'period-error',
        message: this.t_attr('PaycheckPeriod', 'isLocked'),
      };
    }
    if (this.isCurrentPeriod) {
      return {
        icon: 'exclamation-triangle',
        className: 'period-warning',
        message: this.$t('PaycheckPeriod.isCurrentPeriod'),
      };
    }
    if (this.isNextMonth) {
      return {
        icon: 'exclamation-triangle',
        className: 'period-warning',
        message: this.$t('PaycheckPeriod.isOneMonthInAdvance'),
      };
    }
    if (this.isMoreThanTwoMonthsInPast) {
      return {
        icon: 'exclamation-triangle',
        className: 'period-warning',
        message: this.$t('PaycheckPeriod.isMoreThanTwoMonthsInPast'),
      };
    }
    if (this.isMoreThanOneMonthInFuture) {
      return {
        icon: 'times-circle',
        className: 'period-error',
        message: this.$t('PaycheckDraft.cannotCreatePaychecksInAdvance'),
      };
    }
    return null;
  }

  private get isCurrentPeriod(): boolean {
    return this.paycheckPeriod.bookkeepingPeriod === this.$dayjs().format('YYYY-MM');
  }

  private get isMoreThanTwoMonthsInPast(): boolean {
    return this.$dayjs(this.paycheckPeriod.bookkeepingPeriod, 'YYYY-MM', true).diff(this.$dayjs(), 'months') < -2;
  }

  private get isMoreThanOneMonthInFuture(): boolean {
    return this.$dayjs(this.paycheckPeriod.bookkeepingPeriod, 'YYYY-MM', true).diff(this.$dayjs().format('YYYY-MM'), 'months') > 1;
  }

  private get isNextMonth(): boolean {
    return this.$dayjs(this.paycheckPeriod.bookkeepingPeriod, 'YYYY-MM', true).diff(this.$dayjs().format('YYYY-MM'), 'months') === 1;
  }
}
